export const listingConfigDrawer = {
  close: `Fermer`,
  componentUnavailable: `Composant non disponible.`,
};
